import { useTranslation } from 'react-i18next';

interface LoginRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
  message?: string;
}

export function LoginRequiredModal({
  isOpen,
  onClose,
  onLogin,
  message,
}: LoginRequiredModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative z-10 w-full max-w-sm mx-4">
        <div className="rounded-2xl bg-[#141414] border border-white/10 p-6 text-center">
          {/* Icon */}
          <div className="w-14 h-14 rounded-full bg-[#00D2BE]/10 flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-[#00D2BE]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>

          {/* Title */}
          <h2 className="text-xl font-bold text-white mb-2">
            {t('auth.loginRequired.title')}
          </h2>

          {/* Message */}
          <p className="text-sm text-white/60 mb-6">
            {message || t('auth.loginRequired.message')}
          </p>

          {/* Actions */}
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 rounded-lg text-sm font-medium text-white/60 bg-white/10 hover:bg-white/15 transition-colors"
            >
              {t('auth.loginRequired.closeButton')}
            </button>
            <button
              onClick={onLogin}
              className="flex-1 px-4 py-2.5 rounded-lg text-sm font-bold text-black bg-[#00D2BE] hover:bg-[#00D2BE]/90 transition-colors"
            >
              {t('auth.loginRequired.loginButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
